function isIdentityScale(scale) {
  return scale === undefined || scale === 1;
}
function hasScale(_a) {
  var scale = _a.scale,
    scaleX = _a.scaleX,
    scaleY = _a.scaleY;
  return !isIdentityScale(scale) || !isIdentityScale(scaleX) || !isIdentityScale(scaleY);
}
function hasTransform(values) {
  return hasScale(values) || hasTranslate(values.x) || hasTranslate(values.y) || values.z || values.rotate || values.rotateX || values.rotateY;
}
function hasTranslate(value) {
  return value && value !== "0%";
}
export { hasScale, hasTransform };